import { SourceDataInitials } from '@/constants/SourceDataInitials';
import ICompFinalSourceDatas from './ICompFinalSourceDatas';

export default {
    existsByFieldName(sourceDatas: ICompFinalSourceDatas, fieldName: string): boolean {
        for (const sourceData of sourceDatas) {
            if (sourceData.fieldName === fieldName) {
                return true;
            }
        }
        return false;
    },

    containsValueFromSource(sourceDatas: ICompFinalSourceDatas, sourceInitial: SourceDataInitials): boolean {
        const sourceData = sourceDatas.find(sd => sd.sourceInitial === sourceInitial);
        return sourceData ? true : false;
    },

    containsValueFromSource36(sourceDatas: any, sourceInitial: SourceDataInitials): boolean {
        const normalizedSourceInitial = String(sourceInitial || '').toLowerCase();

        const containsInNode = (node: any): boolean => {
            if (!node) {
                return false;
            }

            if (Array.isArray(node)) {
                for (const item of node) {
                    if (containsInNode(item)) {
                        return true;
                    }
                }
                return false;
            }

            if (typeof node !== 'object') {
                return false;
            }

            const nodeSourceInitial = String(node?.sourceInitial || '').toLowerCase();
            if (nodeSourceInitial === normalizedSourceInitial) {
                return true;
            }

            const keys = Object.keys(node);
            for (const key of keys) {
                const value = node[key];
                if (containsInNode(value)) {
                    return true;
                }
            }

            return false;
        };

        return containsInNode(sourceDatas);
    }
};
